import { render } from "./checkPhoneNumber.html?vue&type=template&id=0ad97ea0&scoped=true&ts=true&external"
import script from "./CheckPhoneNumber.vue?vue&type=script&lang=ts"
export * from "./CheckPhoneNumber.vue?vue&type=script&lang=ts"

import "./CheckPhoneNumber.vue?vue&type=style&index=0&id=0ad97ea0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad97ea0"]])

export default __exports__